import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  marginLeft: 8,
  marginTop: 8,
  '& .MuiButtonBase-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    backgroundColor: spaceCadet[100],
    color: spaceCadet[500],
    padding: '6px 24px',
    '&.active': {
      borderBottom: `3px solid ${ultraMarine[500]}`,
      backgroundColor: 'white',
    },
  },
  '& .MuiBadge-badge': {
    right: 18,
    top: 14,
    height: 10,
    width: 10,
    fontSize: 10,
    padding: 6,
    minWidth: 0,
  },
});

export default StyledBox;
